import { numberToPrettyString } from '@cian/utils';

import { IOffer } from '../../../types/offer';
import { getCurrencySign } from '../price/getCurrencySign';

export function getCommercialIncomeTitle(offer: IOffer): string | undefined {
  const { monthlyIncome } = offer;

  if (!monthlyIncome || !monthlyIncome.income) {
    return undefined;
  }

  return `Прибыль ${numberToPrettyString(monthlyIncome.income)} ${getCurrencySign(monthlyIncome.currency)}/мес.`;
}
